import { useQuery } from '@tanstack/vue-query';
import { toValue, MaybeRef } from 'vue';
import { api } from '@/hooks/axios-api';


const fetchSchemesTariffCodesRates = async (applicableYear?: string) => {
  const params = applicableYear ? { applicable_year: applicableYear } : {};
  const response = await api.get('/tools/schemes-tariff-codes-rates/', { params });
  return response.data;
}

const fetchPerSchemeTariffCodesRates = async (applicableYear?: string, schemeId?: string) => {
  // TODO: Use schemeId rather than schemeName. Update API to work with schemeId
  const params = applicableYear ? { applicable_year: applicableYear, scheme_id: schemeId } : {};
  const response = await api.get('/tools/schemes-tariff-codes-rates/', { params });
  console.log('API Response for Per Scheme Tariff Codes Rates:', response.data);
  return response.data;
}

const fetchApplicableYearTariffCodes = async (applicableYear?: string) => {
  const params = applicableYear ? { applicable_year: applicableYear } : {};
  const response = await api.get('/tools/ay-tariff-codes/', { params });
  return response.data;
}



///////////////////// HOOKS //////////////////////////// 

export const useFetchSchemesTariffCodesRates = (applicableYear: MaybeRef<string>) =>
  useQuery({
    queryKey: ["schemesTariffCodesRates", applicableYear],
    queryFn: () => fetchSchemesTariffCodesRates( toValue(applicableYear)),
    // refetchInterval: 3000
    refetchOnWindowFocus: true,
});

export const useFetchPerSchemeTariffCodesRates = (applicableYear: string, schemeId: string) =>
  useQuery({
    queryKey: ["schemeTariffCodesRates", applicableYear, schemeId],
    queryFn: () => fetchPerSchemeTariffCodesRates(applicableYear, schemeId),
    // refetchInterval: 3000
    refetchOnWindowFocus: true,
});


export const useFetctApplicableYearTariffCodes = (applicableYear: string) =>
  useQuery({
    queryKey: ["tariffCodes", applicableYear],
    queryFn: () => fetchApplicableYearTariffCodes(applicableYear),
    // refetchInterval: 3000
    refetchOnWindowFocus: true,
});
